import {
  HeadlineAlign,
  HeadlineColor,
  HeadlineLevel,
} from '@uikit/components/Headline/consts';
import Headline from '@uikit/components/Headline/Headline';
import type { ModalHeaderProps } from '@uikit/components/Modal/interfaces';
import RichText from '@uikit/components/RichText/RichText';

const ModalHeader = ({
  headline,
  headlineLevel = HeadlineLevel.Two,
  headlineColor = HeadlineColor.Gradient,
  description,
  children,
}: ModalHeaderProps): JSX.Element => {
  return (
    <>
      <Headline
        headlineColor={headlineColor}
        level={headlineLevel}
        align={HeadlineAlign.Center}
      >
        {headline}
      </Headline>
      {(description || children) && (
        <>
          <br />
          <RichText size="medium">{description || children}</RichText>
        </>
      )}
    </>
  );
};

export default ModalHeader;
